/**
 * @generated SignedSource<<05c2c1586448704458b4ca207857b33f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type EntityType = "ANSWER" | "ART" | "BELIEF" | "BOOK" | "CHAPTER" | "EXAM" | "GENERIC" | "LESSON" | "PERSON" | "QUESTION" | "TECH" | "THEORY" | "VIDEO" | "%future added value";
export type PublicPostsQuery$variables = {};
export type PublicPostsQuery$data = {
  readonly posts: ReadonlyArray<{
    readonly createdAt: string | null;
    readonly darkThemeImageUrl: string | null;
    readonly entityType: EntityType | null;
    readonly imageUrl: string | null;
    readonly lightThemeImageUrl: string | null;
    readonly percentage: number | null;
    readonly permalink: string | null;
    readonly title: string | null;
  } | null> | null;
};
export type PublicPostsQuery = {
  response: PublicPostsQuery$data;
  variables: PublicPostsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "where",
        "value": {
          "status": "PUBLIC"
        }
      }
    ],
    "concreteType": "Post",
    "kind": "LinkedField",
    "name": "posts",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "permalink",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "percentage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "darkThemeImageUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lightThemeImageUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "entityType",
        "storageKey": null
      }
    ],
    "storageKey": "posts(where:{\"status\":\"PUBLIC\"})"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PublicPostsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PublicPostsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "e53f2bdc9166805ce1ec3bd9a4fa240f",
    "id": null,
    "metadata": {},
    "name": "PublicPostsQuery",
    "operationKind": "query",
    "text": "query PublicPostsQuery {\n  posts(where: {status: PUBLIC}) {\n    permalink\n    title\n    createdAt\n    percentage\n    imageUrl\n    darkThemeImageUrl\n    lightThemeImageUrl\n    entityType\n  }\n}\n"
  }
};
})();

(node as any).hash = "225a3d6952a937823f992cfe727d7ab2";

export default node;
